<template>
  <v-app>
    <div class="home">
      <cheji />
      <common-video
        :textImg="require('../assets/imgs/home/text-1.png')"
        :videoImg="require('../assets/topbanner/0.jpg')"
        videoSrc="https://cdnv.vincicar.net/video/installstep20191227.mp4"
        videoPoster="https://cdnv.vincicar.net/video/installstep20191201.thumb.jpg"
        bottomText="软件安装 详细视频"
      />
      <common-video
        :textImg="require('../assets/imgs/home/text-2.png')"
        :videoImg="require('../assets/topbanner/3.jpg')"
        videoSrc="https://cdnv.vincicar.net/video/xiaoguo20191210.mp4"
        videoPoster="https://cdnv.vincicar.net/video/xiaoguo20191210.thumb.jpg"
        bottomText="优化安装软件后实拍"
      />
      <xcx-swiper />
      <common-video
        :textImg="require('../assets/imgs/home/text-4.png')"
        :videoImg="require('../assets/imgs/al/a1.jpg')"
        videoSrc="https://cdnv.vincicar.net/video/al20191231.mp4"
        videoPoster="https://cdnv.vincicar.net/video/al20191231.thumb.jpg"
        bottomText="互联桌面视频演示"
      />
      <common-introduce
        :textImg="require('../assets/imgs/home/text-5.png')"
        :introImg="require('../assets/topbanner/1.jpg')"
        text="免费更新、实时路况、语音导航、手机互联"
      />
      <common-introduce
        :textImg="require('../assets/imgs/home/text-6.png')"
        :introImg="require('../assets/topbanner/2.jpg')"
        text="动态歌词、无损音乐、丰富音效、在线下载"
      />
      <common-introduce
        :textImg="require('../assets/imgs/home/text-7.png')"
        :introImg="require('../assets/topbanner/3.jpg')"
        text="实况体育、电视剧、美女主播、应有尽有"
      />
      <common-introduce
        :textImg="require('../assets/imgs/home/text-8.png')"
        :introImg="require('../assets/topbanner/4.jpg')"
        text="摇滚、R&B、低音强化、营造顶级视听盛宴"
      />
      <button-bar />
    </div>
  </v-app>
</template>

<script>
import Cheji from '../components/home/Cheji.vue';
import XcxSwiper from '../components/home/XcxSwiper.vue';
import ButtonBar from '../components/home/ButtonBar.vue';
import CommonVideo from '../components/home/CommonVideo.vue';
import CommonIntroduce from '../components/home/CommonIntroduce.vue';

export default {
  name: 'Home',
  components: {
    Cheji,
    XcxSwiper,
    CommonVideo,
    ButtonBar,
    CommonIntroduce,
  },
};
</script>

<style lang="less" scoped>
.home {
  padding-bottom: 148px;
  padding-bottom: calc(148px + constant(safe-area-inset-bottom));
  padding-bottom: calc(148px + env(safe-area-inset-bottom));
  background-image: url('../assets/imgs/home/home-bg.png');
  background-repeat: repeat-y;
  background-size: contain;
}
</style>
